<template>
  <div class="upload">
    <div class="upload_header">
        <img class="upload_t_logo" src="../../assets/img/Logo.png" alt="">
        <!-- <span class="upload_t_btn">Sign up</span> -->
    </div>
    <div class="upload_body">
        <el-form class="form_box" label-position="top" label-width="130px">

          <el-form-item>
            <div class="form_tit">{{$t('main.text211')}}</div>
            <!-- <div class="form_tit2">{{$t('main.text212')}}</div> -->
          </el-form-item>

          <el-form-item :label="$t('main.text213')" class="top_margin">
            <el-input v-model.trim="pwd" :type="pwdType == true ? 'password' : 'text'"></el-input>
            <span class="show-pwd" @click="pwdType = !pwdType">
              <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
            </span>
          </el-form-item>

          <el-form-item :label="$t('main.text214')">
            <el-input v-model.trim="confirm_pwd" :type="pwdType2 == true ? 'password' : 'text'"></el-input>
            <span class="show-pwd" @click="pwdType2 = !pwdType2">
              <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
            </span>
          </el-form-item>

          <el-form-item>
              <el-button class="Submit_btn" @click="Confirm_btn">{{$t('main.text130')}}</el-button>
          </el-form-item>

        </el-form>
    </div>
  </div>
</template>

<script>
import {forgetLoginPassword} from '@/api/api';
import md5 from 'js-md5';

export default {
    data() {
        return {
            pwd_yes: require("../../assets/img/eye_no.png"),
            pwd_no: require("../../assets/img/eye_yes.png"),
            pwdType: true,
            pwdType2: true,
            pwd:'',
            confirm_pwd:'',
            str:'',
        }
    },
    mounted() {
        let str = location.search;
        let str2;
        if(str){
            str2=str.substr(1);
            str2=str.split('=');
            this.str=str2[1];
        }
    },
    methods:{
        Confirm_btn(){
            if(this.pwd==''){
                this.message.ismessage('error',this.$t('main.text207'));
                return false;
            }
            if(this.confirm_pwd==''){
                this.message.ismessage('error',this.$t('main.text208'));
                return false;
            }
            var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/;
            if(!reg.test(this.pwd)){
                this.message.ismessage('error',this.$t('main.text246'));
                // alert("密码只能为大写字母+小写字母+数字的8至12位字符组合");
                return false;
            }

            if(this.pwd!=this.confirm_pwd){
                this.message.ismessage('error',this.$t('main.text209'));
                return false;
            }
            forgetLoginPassword({
                str:this.str,
                password:md5(this.pwd),
                confirm_password:md5(this.confirm_pwd)
            }).then(res=>{
                if (res.data.code==200) {
                    this.message.ismessage('success',this.$t('main.text215'));
                    this.$router.push({path:'/login',query:{reset_pwd_box:true}});
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })

        }
    }
}
</script>

<style scoped>
.upload_header{
    height: 104px;
    background: #041728;
    display: flex;
    position: relative;
}
.upload_body{
    height: calc(100vh - 104px);
}
.upload_t_logo{
    width: 195px;
    margin: auto;
}
.upload_t_btn{
  border: 1.5px solid #F1C787;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #F1C787;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0,-50%);
}
.form_box{
    max-width: 420px;
    margin: auto;
}
.form_tit{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #314869;
    margin-top: 90px;
}
.form_tit2{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: rgba(49, 72, 105, 0.6);
    margin-top: 5px;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
    background: rgba(222, 185, 129, 0.04);
    border: 1.5px dashed #DEB981;
    border-radius: 4px;
    width: 100%;
    height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(49, 72, 105, 0.6);
}
.upload_btn{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    border-color: #F1C788;
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #fff;
    margin: 12px auto;
}
.box_top_tit{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: rgba(49, 72, 105, 0.8);
    margin-bottom: 12px;
}
.el-form-item {
    margin-bottom: 15px;
}
.add_btn{
    width: 214px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #DEB981;
    border: 1px solid #DEB981;
    cursor: pointer;
    margin: 30px auto;
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #fff;
    margin-top: 30px;
}
.upload >>> .el-form--label-top .el-form-item__label{
    padding: 0;
}
.el-form-item__label {
    line-height: initial;
}
.top_margin{
    margin-top: 40px;
}
.login >>> .el-form--label-top .el-form-item__label{
  color: #5A6D87;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
    .form_box{
        width: 80%;
    }
}
</style>